// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__nCrk1","logo":"Navbar_logo__WjNMT","menu":"Navbar_menu__CdC6t","link":"Navbar_link__srvb+","logoImage":"Navbar_logoImage__qNskN"};